if (!customElements.get('adev-sticky-atc')) {
    customElements.define('adev-sticky-atc', class adevStickyAtc extends HTMLElement {
        constructor() {
            super();
            this.selectorToPass = 'product-form-component';
            this.onAddToCartClick = this.onAddToCartClick.bind(this);
            this.onScroll = this.onScroll.bind(this);
            this.scrollRafPending = false;
        }

        initButton() {
            const button = this.querySelector('[data-adev-sticky-atc="button"]');
            if (!button) return;

            button.addEventListener('click', this.onAddToCartClick);
        }

        onAddToCartClick() {
            const target = document.querySelector(this.selectorToPass);
            if (!target) return;

            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        destroyButton() {
            const button = this.querySelector('[data-adev-sticky-atc="button"]');
            if (!button) return;

            button.removeEventListener('click', this.onAddToCartClick);
        }

        isElementInViewport(element) {
            const rect = element.getBoundingClientRect();
            return rect.bottom > 0 && rect.top < window.innerHeight;
        }

        onScroll() {
            if (this.scrollRafPending) return;
            this.scrollRafPending = true;
            requestAnimationFrame(() => {
                this.scrollRafPending = false;
                this.updateStickyState();
            });
        }

        updateStickyState() {
            const target = document.querySelector(this.selectorToPass);
            if (!target) return;

            const isScrolledAtTheBottomOfThePage = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
            const hasScrolledPastForm = target.getBoundingClientRect().bottom <= 0;
            const newProductListSection = document.querySelector('.new-product-list');
            const isNewProductListVisible = newProductListSection
                ? this.isElementInViewport(newProductListSection)
                : false;

            if (isScrolledAtTheBottomOfThePage || !hasScrolledPastForm || isNewProductListVisible) {
                this.classList.remove('is--active');
            } else {
                this.classList.add('is--active');
            }
        }

        init() {
            const target = document.querySelector(this.selectorToPass);
            if (!target) return;

            window.addEventListener('scroll', this.onScroll, { passive: true });
        }

        destroy() {
            window.removeEventListener('scroll', this.onScroll);
        }

        connectedCallback() {
            this.init();
            this.initButton();
        }

        disconnectedCallback() {
            this.destroy();
            this.destroyButton();
        }

    });
}